import React from 'react';

const ErrorMessageFormatter = {
    formatFormSubmissionErrors: (errors) => {
        const title = 'Please fix the below errors.';

        const errorMessageList = errors.map((error, idx) => <li key={idx}>{error}</li>);

        return (
            <div>
                <h4>{title}</h4>
                <ul>{errorMessageList}</ul>
            </div>
        );
    },
};

export default ErrorMessageFormatter;



/** WEBPACK FOOTER **
 ** ./src/services/error-message-formatter.jsx
 **/